import { render, staticRenderFns } from "./SomethingWentWrong.vue?vue&type=template&id=649f64f0&scoped=true&"
var script = {}
import style0 from "./SomethingWentWrong.vue?vue&type=style&index=0&id=649f64f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649f64f0",
  null
  
)

export default component.exports